import { ThreadChannel, ThreadChannelTask } from '@@types/Channel';
import { CHANNEL_ID, MEMBER_ID, THREAD_CHANNEL_ID } from '@@types/common';

import Actions from '~/stores/Actions';
import { threadDetailUiState } from '~/stores/DetailUiState';
import { threadChannelStore } from '~/stores/ThreadChannelStore';
import { uiState } from '~/stores/UiState';
import { omit, uniqBy } from 'ramda';

class ThreadChannelMessageHandler {
  constructor(private actions: Actions) {}

  public handleMemberJoin = ({ channelId, memberIds }: { channelId: THREAD_CHANNEL_ID; memberIds: MEMBER_ID[] }) => {
    threadChannelStore.appendMembers(channelId, memberIds);
  };

  public handleMemberLeave = ({ channelId, memberId }: { channelId: THREAD_CHANNEL_ID; memberId: MEMBER_ID }) => {
    threadChannelStore.removeMember(channelId, memberId);
  };

  public handleChannelDelete = (channel: Partial<ThreadChannel>) => {
    const { channelId } = channel;
    if (channelId === threadDetailUiState.contentsChannelId) {
      this.actions.threadChannelActions.clearThreadPanel({
        close: false,
        dummyParentLogId: channel.parentChannelLogId,
      });
    }
    threadChannelStore.deleteChannel(channelId);
  };

  public handleThreadStatusUpdate = ({ hasUnread }: { hasUnread: boolean }) => {
    uiState.setHasUnreadThread(hasUnread);
  };

  public handleTaskCreate = ({
    channelId,
    ...params
  }: Omit<ThreadChannelTask, 'id'> & { taskId: string; channelId: THREAD_CHANNEL_ID; parentChannelId: CHANNEL_ID }) => {
    if (threadDetailUiState.contentsChannelId !== channelId) {
      return;
    }
    const list = threadChannelStore.taskListMap[channelId] || [];
    threadChannelStore.setThreadChannelTasks(
      channelId,
      uniqBy((item) => item.id, [...list, { ...omit(['parentChannelId', 'taskId'], params), id: params.taskId }])
    );
  };

  public handleTaskDelete({ channelId, taskId }: { channelId: string; taskId: string }) {
    if (threadDetailUiState.contentsChannelId !== channelId) {
      return;
    }
    const list = (threadChannelStore.taskListMap[channelId] || []).filter((task) => task.id !== taskId);
    threadChannelStore.setThreadChannelTasks(channelId, list);
  }
}

export default ThreadChannelMessageHandler;
